"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEvent = void 0;
const trackEvent = (data) => {
    const { path, application, eventData } = data;
    try {
        if (typeof window.melidata === 'function') {
            const track = {};
            window.melidata('createEventTrack', track);
            window.melidata('withPath', path, track);
            window.melidata('withData', eventData, track);
            if (application) {
                window.melidata('withApplicationData', application, track);
            }
            window.melidata('sendTrack', track);
        }
    }
    catch (e) {
        window.newrelic?.noticeError(`Error sending track for Melidata: ${e}`);
    }
};
exports.trackEvent = trackEvent;
